module.exports = __webpack_public_path__ + "img/Frame 7116.8ac451dd.png";